







































import {Component, Vue} from 'vue-property-decorator';
import TableRoute from '@c/tables/TableRoute.vue';
import RenameDialog from '@c/RenameDialog.vue';
import {Can} from '@casl/vue';
import {VibrationDiagnosticTableHeader} from './interfaces';
import vibrationDiagnosticStoreModule from '@/store/modules/services/vibrationDiagnosticModule';

@Component({
  components: {
    TableRoute,
    RenameDialog,
    Can,
  },
})
export default class VibrationDiagnosticView extends Vue {
  headers: VibrationDiagnosticTableHeader[] = [
    {
      text: 'Наименование',
      value: 'name',
      sortable: false,
    },
  ];

  get apiStore() {
    return vibrationDiagnosticStoreModule;
  }

  get renameDialog() {
    return this.$refs.renameDialog as any;
  }

  rename(event: any, item: any) {
    const clone_item = {...item};
    this.renameDialog.open(clone_item, {
      saveCallback: async (data: any) => {
        try {
          await this.apiStore.save(data);
          this.renameDialog.close();
          await this.apiStore.fetchAll();
        } catch (e) {
          this.renameDialog.error('Произошла ошибка');
        }
      },
    });
    event.stopPropagation();
  }

  onClickRow(item: any) {
    this.$router.push({
      name: 'EditVibrationDiagnostic',
      params: {id: `${item.id}`, openDialog: 'false'},
    });
  }
}
